import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=2baead3c&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=js&"
export * from "./dialog.vue?vue&type=script&lang=js&"
import style0 from "@/components/dialogs/dialog.scss?vue&type=style&index=0&id=2baead3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baead3c",
  null
  
)

export default component.exports